import { useMutation } from '../';
import { newPortfolioMutation } from '../mutations';

export function useNewPortfolioMutation() {
  const { data, isLoading, mutate } = useMutation();
  
  const run = (variables, onFinish, onError) => {
    mutate(newPortfolioMutation, variables, (response) => {
      if (typeof onFinish === 'function') {
        onFinish(response.newPortfolio.id);
      }
    }, () => {
      if (typeof onError === 'function') {
        onError();
      }
    });
  };

  return { data, isLoading, run };
}
